import { useState, useCallback, useMemo } from 'react';
import React from 'react';
import { getDmImei, getDms, writeRsCmdSettings } from '../../../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import ParametrPch from './ParametrPch';
import SelectDeviceRs from './SelectDeviceRs';
import SelectConfigRs from './SelectConfigRs';
import Button from "../../../UI/Button/Button";
import Modal from '../../../UI/Modal/Modal'
import {Loader} from '../../../UI/Loader/Loader';
import '../RsConfig.css'

export default React.memo (function RsPassport() {
    const parameter = useSelector((state) => state.dmimei.data[0]);
    const role = useSelector((state) => state.userdata?.role);
    const dispatch = useDispatch();
    const iduser = localStorage.getItem('iduser');

    // Централизованное состояние для всех модальных окон
    const [modalState, setModalState] = useState({
        isOpen: false,
        modalType: null, // 'name', 'type', или 'param'
        inputValue: '',
        hasError: false,
        currentParam: null,
        currentIndex: null,
        isLoading: false
    });

    // Мемоизированные данные
    const nameRs = useMemo(() => parameter?.imei_name || '...', [parameter?.imei_name]);       

    // Общие обработчики модального окна
    const handleModalOpen = useCallback((modalType, currentParam = null, currentIndex = null) => {
        let initialValue = '';
        if (modalType === 'name') initialValue = nameRs;
        
        setModalState({
            isOpen: true,
            modalType,
            inputValue: initialValue,
            hasError: false,
            currentParam,
            currentIndex,
            isLoading: false
        });
    }, [nameRs]);

    const handleModalClose = useCallback(() => {
        setModalState(prev => ({ ...prev, isOpen: false }));
    }, []);

    const handleInputChange = useCallback((e) => {
        setModalState(prev => ({ ...prev, inputValue: e.target.value }));
    }, []);

    // Унифицированная функция сохранения
    const handleSave = useCallback(async () => {
        const { modalType, inputValue, currentIndex } = modalState;
        
        if (!inputValue || inputValue==="..." || inputValue===' ') {
            setModalState(prev => ({ ...prev, hasError: true }));
            return;
        }

        try {
            setModalState(prev => ({ ...prev, isLoading: true }));
            
            let num, value;
            switch(modalType) {
                case 'name':
                    num = 20;
                    value = inputValue;
                    break;
                
                default:
                    return;
            }

            await dispatch(writeRsCmdSettings(parameter?.imei, value, num));
            await dispatch(getDmImei(parameter?.imei));
            if (modalType === 'name' || modalType === 'param') {
                await dispatch(getDms(iduser));
            }

            handleModalClose();
        } catch (error) {
            console.error("Ошибка при сохранении или обновлении данных: ", error);
        } finally {
            setModalState(prev => ({ ...prev, isLoading: false }));
        }
    }, [modalState, parameter?.imei, dispatch, handleModalClose, iduser]);

    // Оптимизированный компонент для установки имени
    const SetNameRs = useCallback(() => (
        <div className='ParamInput'>
            <label>Название:</label>
            {modalState.isLoading && modalState.modalType === 'name' ? <Loader /> :
                <Button className='ParamInputButton' onClick={() => handleModalOpen('name')}>
                    <span className='buttonInput'>{nameRs}</span>
                </Button>
            }
        </div>
    ), [nameRs, handleModalOpen, modalState.isLoading, modalState.modalType]);

    return (
        <div className='cardDm'>
            <h3>Общие настройки</h3>
            <SetNameRs />

            {role===1 && <>
                <h3>Настройки модема</h3>
                <div className='PassportSettings'> 
                    <SelectDeviceRs />
                    <SelectConfigRs />
                </div>
            </>
            }

           {parameter?.typeRsDevice_name!=='PLC' && <> 
                <h3>Настройки ПЧ</h3>
                <div className='PassportSettings'>
                    <ParametrPch />
                </div>
            </> }


            {/* Единое модальное окно */}
            <Modal open={modalState.isOpen}>
                <div className='modalHeader'>
                    <h3>Введите новое значение</h3>
                    <svg onClick={handleModalClose} height="30" viewBox="0 0 200 200" width="30">    
                        <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                    </svg> 
                </div>
                <div className='modalInfo'> 
                    <label className='labelInfo'>

                        {modalState.modalType === 'name' && (
                            parameter?.type === "RS485" 
                            ? 'Название насосной:' 
                            : 'Название дождевальной машины:'
                        )}

                    </label>
                    <h4 className='labelInfoQuet'>
                        {modalState.hasError 
                            ? "Передумали?" 
                            : `Желаете установить ${modalState.inputValue}?`}
                    </h4>
                </div>
                <div className='contentControl'>
                    <input 
                        type='text'
                        className='input' 
                        value={modalState.inputValue} 
                        onChange={handleInputChange}
                        style={{ border: modalState.hasError ? '1px solid red' : null }} 
                    />
                    <div className='modalButton'>
                        <Button onClick={handleModalClose} color="#d2e9d2">Отмена</Button>
                        <Button onClick={handleSave} color="#4bdd4b">Сохранить</Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
});
  